const VITRankings = () => (
    <section className="container mt-4 custom-bg rounded fade-up p-4">
      <h3 className="text-center mb-3">VIT Rankings & Accreditations</h3>
      <div className="row">
        <div className="col-12 col-md-6">
          <ul className="list-unstyled">
            <li>&#8226; <strong>Engineering and Technology:</strong> 142nd in the World, 9th in India (QS World University Rankings by Subject 2025)</li>
            <li>&#8226; Four subjects (CS & IT, Data Science & AI, EEE, Material Science) ranked among the top 200 globally (QS World University Rankings by Subject 2025)</li>
            <li>&#8226; NAAC Accreditation with A++ grade (3.66 out of 4)</li>
          </ul>
        </div>
        <div className="col-12 col-md-6">
          <ul className="list-unstyled">
            <li>&#8226; 2nd in India, 501-600 in the world (Shanghai ARWU Ranking 2024)</li>
           
            <li>&#8226; 10th best University, 13th best research institution, 11th best engineering institution in India (NIRF Ranking, Govt. of India 2024)</li>
          
            <li>&#8226; 396th in the world, 8th in India (QS World University Rankings: Sustainability 2025)</li>
          </ul>
        </div>
      </div>
    </section>
  );
  
  export default VITRankings;
  